import { heroStats } from "@/mocks/homeData";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      {/* big visual */}
      <div className="relative h-[560px] md:h-[680px] w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20artwork%20of%20a%20crowded%20night%20town%20square%20alive%20with%20chat%20bubbles%20and%20spotlights%2C%20gossip%20community%20discussion%20vibe%2C%20deep%20warm%20coral%20red%20amber%20gold%20and%20dark%20charcoal%20palette%2C%20cinematic%20editorial%20illustration%2C%20no%20realistic%20faces%2C%20high%20contrast%20for%20text%20readability&width=1800&height=980&seq=hero-2026-17hl&orientation=landscape"
          alt="17黑料热议广场"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-background-950/90" />

        {/* content */}
        <div className="relative z-10 mx-auto flex h-full w-full max-w-7xl flex-col items-center justify-center px-4 text-center md:px-6">
          <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs tracking-wider text-background-100 backdrop-blur">
            <i className="ri-fire-line text-accent-400"></i>
            围观群众都在聊什么 · 今日热议持续更新
          </span>
          <h1 className="font-heading text-3xl leading-tight font-bold text-background-50 sm:text-4xl md:text-6xl">
            17黑料 · 热议不停
          </h1>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/95 md:text-base">
            热门话题、网友评论、各方观点都在这里。搬好小板凳，围观最新热议动态，加入这场公开的讨论，永远不错过下一个反转。
          </p>
          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
            <button
              onClick={() => document.getElementById("rank")?.scrollIntoView({ behavior: "smooth" })}
              className="whitespace-nowrap rounded-full bg-primary-500 px-8 py-3.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600 md:px-9"
            >
              先看看热议榜
            </button>
            <button
              onClick={() => document.getElementById("viewpoint")?.scrollIntoView({ behavior: "smooth" })}
              className="whitespace-nowrap rounded-full border border-background-50/40 px-8 py-3.5 text-sm font-semibold text-background-50 backdrop-blur transition hover:bg-background-50/15"
            >
              进来站个观点
            </button>
          </div>
        </div>
      </div>

      {/* stats strip overlapping */}
      <div className="relative z-20 mx-auto -mt-10 w-full max-w-5xl px-4 md:-mt-12 md:px-6">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-background-200 bg-background-200 sm:grid-cols-4">
          {heroStats.map((s) => (
            <div key={s.label} className="flex flex-col items-center justify-center gap-1 bg-background-50 px-4 py-6 text-center md:py-7">
              <span className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">{s.value}</span>
              <span className="text-xs text-foreground-600">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}